// @ts-nocheck

import { Icon, IconType } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { PROFILE_PICTURE_PLACEHOLDER } from '../../../common/constants'

export default class ProfilePicture extends Component<any, any> {
  shouldComponentUpdate(nextProps) {
    const currentUrl = this.props.url || PROFILE_PICTURE_PLACEHOLDER
    const nextUrl = nextProps.url || PROFILE_PICTURE_PLACEHOLDER
    if (
      currentUrl &&
      nextUrl &&
      `${currentUrl}`.split(/\?/)[0] === `${nextUrl}`.split(/\?/)[0]
    ) {
      return false
    }
    return true
  }

  render() {
    const { edit, onClick, style, size, type, url, ...props } = this.props
    const className = type
      ? `lmc-profile-picture__${type}`
      : 'lmc-profile-picture'
    const backgroundUrl = url || PROFILE_PICTURE_PLACEHOLDER
    return (
      <div
        className={size ? props.className : className}
        style={{
          ...style,
          ...styles.wrapper,
          backgroundSize: size ? size + 1 : null,
          width: size || null,
          height: size || null,
          borderRadius: size || null,
          backgroundImage: `url(${backgroundUrl})`,
          cursor: edit ? 'pointer' : null
        }}
        onClick={onClick}
      >
        {edit && (
          <div>
            <div style={styles.editIcon}>
              <Icon customIcon={IconType.Pencil} />
            </div>
            <div style={styles.editOverlay} />
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  editIcon: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    zIndex: 2
  },
  editOverlay: {
    background: 'white',
    height: 1000,
    opacity: 0.5,
    overflow: 'hidden',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    width: 1000
  },
  wrapper: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

ProfilePicture.propTypes = {
  style: PropTypes.object,
  type: PropTypes.string,
  url: PropTypes.string
}
